import React, { Component } from 'react';
import './App.css';
import './Colors.css';

import Home from './Home.js';
import TeamChart from './TeamChart.js';
import CharacterSelect from './CharacterSelect.js';
import FighterStats from './FighterStats.js';
import StatsPage from './StatsPage.js';
import Header from './Header.js';
import MiiSelector from './MiiSelector.js';
import PlayerPopup from './PlayerPopup.js';
import CharacterChart from './CharacterChart.js';
import Popup from './Popup.js';
import { ReactTitle, MetaTags } from 'react-meta-tags';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

class App extends Component {
    constructor(props){
        super(props);
        this.state = {dataSource:0, showPopup:false, width:window.innerWidth, height:window.innerHeight, testPopup:true};
        this.updateColors = this.updateColors.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width:window.innerWidth, height:window.innerHeight });
    }


    filterCharacterChart(type) {
        this.setState(prevState => ({
            dataSource: type
        }));
    }

    updateColors(character) {
        this.setState(prevState => ({
            showPopup:!this.state.showPopup
        }));
    }

    closePopup() {
        console.log("closePopup");
        this.setState({testPopup: false});
    }

    render() {
        return (
            <div className="App">
              <Router>
                <div>
                  <Route><Header/></Route>
                  <Switch>
                    <Route exact path={process.env.PUBLIC_URL + "/"}>
                      <div>
                        <MetaTags>
                          <title>SmashCV</title>
                        </MetaTags>
                        <Home />
                      </div>
                    </Route>
                    <Route exact path={process.env.PUBLIC_URL + "/stats"}>
                      <StatsPage />
                    </Route>
                    {/*<Route exact path={process.env.PUBLIC_URL + "/characters"}>
                          <Popup close={this.closeCSS}>
                                <CharacterSelect />
                                </Popup>
                    </Route>*/}
                    <Route exact path={process.env.PUBLIC_URL + "/team"}>
                      <ReactTitle title="SmashCV - Teams"/>
                      <TeamChart />
                    </Route>
                    <Route exact path={process.env.PUBLIC_URL + "/players"}>
                      <div>
                        <ReactTitle title="SmashCV - Faces of For Glory"/>
                        <MiiSelector count={2342} offset={0} />
                      </div>
                    </Route>
                    <Route exact path={process.env.PUBLIC_URL + "/players/:index"}
                           render={(props) => <MiiSelector {...props} count={2342} offset={0} />}
                      >
                      <ReactTitle title="SmashCV - Faces of For Glory"/>
                    </Route>
                    <Route exact path={process.env.PUBLIC_URL + "/fstats"}>
                      <div>
                        <ReactTitle title="SmashCV - Fighter Stats"/>
                        <FighterStats dataSource={this.state.dataSource}/>
                      </div>
                    </Route>
                    {/*<Route expact path={process.env.PUBLIC_URL + "/test"}>
                          <div>
                                <CharacterSelect />
                                </div>
                                </Route>
                                <Route expact path={process.env.PUBLIC_URL + "/player"}>
                                      <div>
                                            { this.state.testPopup && <PlayerPopup close={this.closePopup}/> }
                                            </div>
                                </Route>*/}
                  </Switch>
                </div>
              </Router>
            </div>
        );
    }
}

export default App;
